export enum TokenValidationMode {
    Local = 0,
    Remote = 1
}